import { motion } from "framer-motion";
import { Coffee, Check } from "lucide-react";
import { STAMPS_PER_REWARD } from "@/lib/api";

export const PunchCard = ({ stamps = 0, size = "md" }) => {
  const slots = Array.from({ length: STAMPS_PER_REWARD });
  const dim = size === "lg" ? "h-16 w-16 sm:h-20 sm:w-20" : "h-12 w-12";
  const iconSize = size === "lg" ? "w-7 h-7 sm:w-9 sm:h-9" : "w-5 h-5";

  return (
    <div className="grid grid-cols-5 gap-3 sm:gap-4" data-testid="punch-card-grid">
      {slots.map((_, i) => {
        const filled = i < stamps;
        return (
          <motion.div
            key={i}
            data-testid={`stamp-slot-${i}`}
            initial={false}
            animate={filled ? { scale: [1, 1.25, 1] } : { scale: 1 }}
            transition={{ duration: 0.35, ease: "easeOut" }}
            className={`${dim} relative flex items-center justify-center rounded-full ${
              filled
                ? "bg-primary/20 ring-2 ring-primary shadow-[0_0_18px_rgba(217,119,6,0.35)]"
                : "ring-1 ring-white/15 bg-white/[0.02]"
            }`}
          >
            {filled ? (
              <Coffee className={`${iconSize} text-primary`} strokeWidth={1.75} />
            ) : (
              <span className="font-mono text-xs text-white/25">{i + 1}</span>
            )}
            {filled && (
              <span className="absolute -top-1 -right-1 flex items-center justify-center w-4 h-4 rounded-full bg-primary text-primary-foreground">
                <Check className="w-2.5 h-2.5" strokeWidth={3} />
              </span>
            )}
          </motion.div>
        );
      })}
    </div>
  );
};
